import { Box, Grid, Typography } from '@mui/material';
import React, { ReactNode } from 'react'
import { Product } from '../../Models/Products';
import { StarBorderOutlined, StarOutlineRounded } from '@mui/icons-material';
import { Link } from 'react-router-dom';

interface ProductProps {
    product: Product;
}

function ProductCard({ product }: ProductProps) {
    return (
        <Link to={`/product-details/${product.variants[0].sku}`} className='text-decoration-none' state={{ product: product }}>
            <Grid
                key={product?.productId}
                size="auto"
                className="border-10 overflow-hidden  d-flex flex-column"
                sx={{
                    width: {
                        xs: "200px",
                        md: "250px",
                        lg: "300px",
                    },
                    height: {
                        xs: "250px",
                        md: "350px",
                        lg: "400px",
                    },
                    flexShrink: 0,
                }}
            >
                <Box
                    sx={{
                        flexGrow: 1,
                        minHeight: 0,
                        overflow: "hidden",
                    }}
                >
                    <Box
                        component="img"
                        className='border-10 bg-light'
                        src={product?.media?.[0]?.media_url}
                        alt={product?.productName}
                        sx={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                        }}
                    />
                </Box>

                <Typography className="text-white fw-bold fs-18 mt-2">
                    {product?.productName}
                </Typography>

                <Box className="d-flex align-items-center gap-1">
                    {[...Array(5)].map((_, index) =>
                        index < (product?.reviews?.length || 0) ? (
                            <StarOutlineRounded
                                key={index}
                                sx={{ color: "#FFD700", fontSize: 20 }}
                            />
                        ) : (
                            <StarBorderOutlined
                                key={index}
                                sx={{ color: "#808080", fontSize: 20 }}
                            />
                        )
                    )}

                    <Typography className="text-white fs-12" gutterBottom>
                        {product?.reviews?.length || 0}
                    </Typography>
                </Box>

                <Typography className='text-white fw-bold fs-18 align-items-baseline'>${product?.discounted_price} {Number(product?.discount_percentage) > 0 && (<span className='over-line fs-16'>${product?.base_price}</span>)} {Number(product?.discount_percentage) > 0 && (<span className='text-green'>&nbsp;{Number(product?.discount_percentage).toFixed(0)}% off</span>)}</Typography>
            </Grid>
        </Link>
    )
}

export default ProductCard
